import { SchmancyElement } from '@schmancy/mixins/index'
import { css, html } from 'lit'
import { customElement, property } from 'lit/decorators.js'

@customElement('schmancy-card-content')
export default class SchmancyCardContent extends SchmancyElement {
	static styles = [
		css`
			/* !important is load-bearing, the same cascade fact schmancy-list's
			   dividers pin: a consumer's baked Tailwind preflight resets every
			   element's padding to 0, and for normal declarations the outer tree
			   wins over :host at any specificity. Importance is what flips
			   context the other way — without it every consumer's global reset
			   silently strips this component's default padding. */
			:host {
				display: block;
				padding: 1rem !important;
			}

			/* An overlay body that must scroll within a fixed-height panel: the
			   host becomes the flexing, self-scrolling child of its own flex
			   parent (a header + this content stacked in a column) rather than a
			   static block that grows past the panel's bounds. */
			:host([scroll]) {
				flex: 1 1 0%;
				min-height: 0;
				overflow-y: auto;
			}
		`,
	]

	// Named `scrolls`, not `scroll` — `Element.prototype.scroll` is a native
	// method, and Lit's decorator refuses to shadow it with a boolean property
	// of the same name. The reflected attribute stays `scroll`, matching the
	// public contract; only the class field carries the different name.
	@property({ type: Boolean, reflect: true, attribute: 'scroll' })
	scrolls = false

	protected render(): unknown {
		return html`<slot></slot>`
	}
}

declare global {
	interface HTMLElementTagNameMap {
		'schmancy-card-content': SchmancyCardContent
	}
}
